import { render, staticRenderFns } from "./JSONViewer.vue?vue&type=template&id=5a5debb5&"
import script from "./JSONViewer.vue?vue&type=script&lang=js&"
export * from "./JSONViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports